import type { Phase, PhaseScheduleEntry } from '@jw-av/content'
import { sortPhases, findScheduleEntry } from '../../lib/learn-data'
import { PhaseCard } from './PhaseCard'

interface ModuleRecord {
  id: string
  title: string
  path: string
  roles: string[]
  phase: string
  stage: string
  slideCount: number
}

interface PhaseTimelineProps {
  phases: Phase[]
  schedule: PhaseScheduleEntry[]
  modules: ModuleRecord[]
  crew: string
  team: 'operations' | 'installation'
  activeRole: string
  completedIds: Set<string>
}

export function PhaseTimeline({
  phases,
  schedule,
  modules,
  crew,
  team,
  activeRole,
  completedIds,
}: PhaseTimelineProps) {
  const sorted = sortPhases(phases)
  return (
    <section className="learn-plan" aria-label="Training phases">
      {sorted.map((phase, i) => (
        <PhaseCard
          key={phase.id}
          index={i}
          phase={phase}
          scheduleEntry={findScheduleEntry(schedule, phase.id, crew, team)}
          modules={modules.filter((m) => m.phase === phase.id)}
          activeRole={activeRole}
          completedIds={completedIds}
        />
      ))}
    </section>
  )
}
